class HeaderMobile {
	constructor() {
		this.header = document.querySelector(".header-main");
		this.toggleMenu = document.querySelector(".toggle-menu");
		this.toggleMenu.addEventListener("click", () => {
			this.header.classList.toggle("nav-open");
		});
	}
}
